import React from 'react';
import { TextButton } from '@wix/design-system';
import style from '../../app-box.module.scss';
export function CTAButton({ onClick, children }) {
    return (React.createElement(TextButton, { className: style.ctaButton, size: "tiny", weight: "normal", onClick: (e) => {
            e.stopPropagation();
            onClick?.();
        } }, children));
}
//# sourceMappingURL=cta-button.js.map